import type { CSSProperties } from 'vue';

export interface UseLineClampOptions {
  lines?: number;
  expand?: MaybeRef<boolean>;
  enabled?: MaybeRef<boolean>;
}

export const useLineClamp = (
  element: Ref<HTMLElement | undefined>,
  options: UseLineClampOptions = {},
) => {
  const { lines = 5, expand = false, enabled = true } = options;

  const [isExpanded, toggle] = useToggle(toValue(expand));

  const isClamped = computed(() => {
    if (!toValue(enabled)) return false;
    if (!element.value) return false;

    return element.value?.scrollHeight > element.value?.clientHeight;
  });

  const style = computed((): CSSProperties => {
    const baseStyles = {
      transition: 'all .25s ease-in',
    };

    if (!toValue(enabled)) return baseStyles;
    if (toValue(isExpanded)) return baseStyles;

    return {
      ...baseStyles,
      'display': '-webkit-box',
      '-webkit-line-clamp': lines,
      '-webkit-box-orient': 'vertical',
      'overflow': 'hidden',
    };
  });

  return {
    isClamped,
    style,
    isExpanded,
    toggle,
  };
};
